export default __webpack_public_path__ + "icon_emergency_help.svg";